import frontMain from "./img-front_main.jpg";
import logoWhite from "./logo-white.png";
import logoColor from "./logo-color.png";
import background from "./loginimage.jpg";
import frendeInsuranceImage from "./FrendeInsuranceImage.jpg";
import horisontalLogo from "./Brage_logo_liggende.png";

import brageBoat from "./BrageBoat.png";
import brageBoatV2 from "./BrageBoatV2.png";
import brageCar from "./BrageCar.png";
import mariCarKey from "./MariCarKey.png";
import vildeCar from "./VildeCar.png";
import vildePhone from "./VildePhone.png";

import greenCarLoan from "./GreenCarLoan.png";
import taxNoteIcon from "./TaxNoteIcon.svg";

import factoring from "./Factoring.svg";
import number1Circle from "./Number1Circle.png";
import number2Circle from "./Number2Circle.png";
import number3Circle from "./Number3Circle.png";
import kristianThink from "./KristianThink.png";

export const menuBannerWhite = [logoWhite];
export const headerLogo = [logoColor];
export const footerLogo = [logoWhite];
export const form_web_logo = [horisontalLogo];

export const mainlogo = [logoColor];
export const dashboard = [frontMain];

export const loginBackground = [background];
export const loginLogo = [logoColor];
export const loginInternalBackground = [background];

export const FrendeInsuranceImage = [frendeInsuranceImage];

export const BrageBoat = [brageBoat];
export const BrageBoatV2 = [brageBoatV2];
export const BrageCar = [brageCar];
export const MariCarKey = [mariCarKey];
export const VildeCar = [vildeCar];
export const VildePhone = [vildePhone];

export const GreenCarLoan = [greenCarLoan];
export const TaxNoteIcon = [taxNoteIcon];

export const Factoring = [factoring];

export const Number1Circle = [number1Circle];
export const Number2Circle = [number2Circle];
export const Number3Circle = [number3Circle];

export const KristianThink = [kristianThink];
